export default {"src":"/_next/static/media/COMPUTADOR.81e13770.gif","height":640,"width":640,"blurWidth":0,"blurHeight":0};